<template>
<div class="MyServices page">
  <!-- Компонент MyServices -->
  <BackBtn />
  <BreadCrumbs :items="breadcrumbs" />
  <div class=" d-flex align-center pb-4 mb-4">
    <h1 class="font-lg">Мои услуги и тесты</h1>
  </div>

  <div class="d-flex banner_preview">
    <BannerPreview :uploadFile="currentBanner" class="w-100" @clickBanner="showModalContact = !showModalContact"/>
  </div>
  <div class="pt-4">
    <div v-for="service of validateServices" :key="service.id">
      <ServicePreview
        v-if="service.status ==='published'"
        :preview="service"
        :profilePage="true"
      />
    </div>
  </div>
  <ModalContactManager
    :showModalContact="showModalContact"
    @acceptSend="goToLink"
    @closeModal="showModalContact = false"
  />
</div>
</template>

<script>
import BannerPreview from '@/components/admin-panel/BannerPreview.vue';
import ModalContactManager from '@/components/list-services/ModalContactManager.vue';
import ServicePreview from '@/components/list-services/ServicePreview.vue';
import { mapActions, mapGetters } from 'vuex';

/**
 * Компонент: MyServices
 * Описание:
 */
export default {
  name: 'MyServices',

  components: {
    ServicePreview,
    ModalContactManager,
    BannerPreview,
  },

  props: {},

  data() {
    return {
      showModalContact: false
    };
  },

  computed: {
    ...mapGetters({
      bannerLinks: 'users/admins/hasBannerLinks',
      user: 'auth/user',
      services: 'services/services/GET_ALL_SERVICES',
    }),
    breadcrumbs() {
      return [
        { title: 'Личный кабинет', url: '/profile' },
        { title: 'Мои услуги и тесты', url: '' },
      ];
    },
    currentBanner() {
      return {
        isUpload: !!this.bannerLinks,
        image: this.bannerLinks ? this.bannerLinks : null,
      };
    },
    validateServices: {
      get() {
        return this.services.filter((service) => service.main_image_url);
      }
    }
  },

  watch: {},

  created() {
  },

  mounted() {
    this.getCurrentBanner();
    this.GET_ALL_SERVICES();
  },

  beforeDestroy() {
  },

  methods: {
    ...mapActions({
      bannerLink: 'users/admins/bannerLink',
      GET_ALL_SERVICES: 'services/services/GET_ALL_SERVICES',
    }),
    getCurrentBanner() {
      return this.bannerLink();
    },
    goToLink() {
      window.open('https://t.me/Team_Assessment', '_blank');
    },
  },
};
</script>

<style scoped lang="scss">
.MyServices {
  /* Стили компонента */
}
</style>
